import { SkeletonBodyText, Text } from '@shopify/polaris';
import { Table } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

const FullfillmentSkeleton = () => {
    const { t } = useTranslation();
    const columns = [
        {
            title: <Text as="p" fontWeight="bold">
                {t("Order ID")}
            </Text>,
            dataIndex: 'id',
            key: 1,
            width: '170px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Status")}
            </Text>,
            dataIndex: 'status',
            key: 2,
            width: '150px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Sync Status")}
            </Text>,
            dataIndex: 'sync_status',
            key: 3,
            width: '75px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Ordered Items")}
            </Text>,
            dataIndex: 'ordered_items',
            key: 4,
            width: '100px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Total Price")}
            </Text>,
            dataIndex: 'total_price',
            key: 5,
            width: '100px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Created At")}
            </Text>,
            dataIndex: 'created_at',
            key: 6,
            width: '100px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Tags")}
            </Text>,
            dataIndex: 'tags',
            key: 7,
            width: '100px',
        },
        {
            title: <Text as="p" fontWeight="bold">
                {t("Actions")}
            </Text>,
            dataIndex: 'actions',
            key: 7,
            width: '140px',
        },
    ];
    const rows = [
        {
            key: '1',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '2',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '3',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '4',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '5',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '6',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '7',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '8',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '9',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '10',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '11',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '12',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '13',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
        {
            key: '14',
            id: <SkeletonBodyText lines={1} />,
            status: <SkeletonBodyText lines={1} />,
            sync_status: <SkeletonBodyText lines={1} />,
            ordered_items: <SkeletonBodyText lines={1} />,
            total_price: <SkeletonBodyText lines={1} />,
            created_at: <SkeletonBodyText lines={1} />,
            tags: <SkeletonBodyText lines={1} />,
            actions: <SkeletonBodyText lines={1} />,
        },
    ];
    return <Table columns={columns} dataSource={rows} scroll={{ x: 768 }} pagination={false} size='middle' />;
}
export default FullfillmentSkeleton;